import React from 'react';
import { InstallationType } from '../../forms/Pergola_type';
import { Trave } from '../Pergola';

// Definisci i tipi per le props
interface Sezione {
  larghezza: number;
  altezza: number;
}

interface CoordinateSystem {
  org: {
    x: number;
    y: number;
    z: number;
  };
  direction: [number, number, number];
}

interface ExtraTraviProps {
  needExtraTrave: boolean;
  sezionePilastro: Sezione;
  larghezzaSoletta: number;
  lunghezzaSoletta: number;
  altezzaPilastro: number;
  texture: any;
  isLatoLibero: (direzione: "Fronte" | "Retro" | "Destra" | "Sinistra") => boolean;
  installazione: InstallationType
}

const ExtraTravi: React.FC<ExtraTraviProps> = ({
  needExtraTrave,
  sezionePilastro,
  larghezzaSoletta,
  lunghezzaSoletta,
  altezzaPilastro,
  texture,
  isLatoLibero,
  installazione
}) => {
  if (!needExtraTrave) return null;

  const offsetZ = altezzaPilastro - sezionePilastro.altezza;
  let traveLunghezzaX = larghezzaSoletta - sezionePilastro.larghezza * 2;
  let traveLunghezzaY = lunghezzaSoletta - sezionePilastro.larghezza * 2;
   
  if((!isLatoLibero("Fronte") && !isLatoLibero("Retro")) || !isLatoLibero("Retro")){
    traveLunghezzaY += sezionePilastro.larghezza * 2;
  }
  if((!isLatoLibero("Sinistra")) || (!isLatoLibero("Sinistra") && !isLatoLibero("Retro"))){
    traveLunghezzaX += sezionePilastro.larghezza * 2;
  }

  return (
    <>
      {/* Trave orizzontale superiore (parallela all'asse X) */}
      <Trave
        sezione={sezionePilastro}
        lunghezza={traveLunghezzaX}
        material={texture}
        cs={{
          org: {
            x: larghezzaSoletta / 2,
            y: sezionePilastro.larghezza / 2,
            z: offsetZ,
          },
          direction: [1, 0, 0],
        }}
      />

      {/* Trave orizzontale inferiore (parallela all'asse X) */}
      <Trave
        sezione={sezionePilastro}
        lunghezza={traveLunghezzaX}
        material={texture}
        cs={{
          org: {
            x: larghezzaSoletta / 2,
            y: lunghezzaSoletta - sezionePilastro.larghezza / 2,
            z: offsetZ,
          },
          direction: [1, 0, 0],
        }}
      />

      {/* Trave verticale destra (parallela all'asse Y) */}
      <Trave
        sezione={sezionePilastro}
        lunghezza={traveLunghezzaY}
        material={texture}
        cs={{
          org: {
            x: larghezzaSoletta - sezionePilastro.larghezza / 2,
            y: lunghezzaSoletta / 2,
            z: offsetZ,
          },
          direction: [0, 1, 0],
        }}
      />

      {/* Trave verticale sinistra (parallela all'asse Y) */}
      <Trave
        sezione={sezionePilastro}
        lunghezza={traveLunghezzaY}
        material={texture}
        cs={{
          org: {
            x: sezionePilastro.larghezza / 2,
            y: lunghezzaSoletta / 2,
            z: offsetZ,
          },
          direction: [0, 1, 0],
        }}
      />
    </>
  );
};

export default ExtraTravi;